import { drawerWidth, transition, container } from "assets/jss/material-dashboard-react.js";

const appStyle = (theme) => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh",
    display: 'flex',
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      height: "100vh",
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
    flexGrow: '1'
  },
  content: {
    marginTop: "65px",
    padding: "0px 15px 30px 15px",
    minHeight: "calc(100vh - 185px)",
  },
  container,
  map: {
    marginTop: "70px",
  },
});

export default appStyle;
